import React from 'react';

/**
 * Underline tab bar (reference: Billing Settings / Usage / Plans).
 *
 * tabs: [{ id, label }]
 * activeId: string
 * onChange: (id) => void
 */
export default function Tabs({ tabs, activeId, onChange, className = '' }) {
  return (
    <div className={`app-tabs ${className}`.trim()} role="tablist">
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`app-tabs__item${active ? ' app-tabs__item--active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
